import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { PropertyStickyPriceHeader } from '@shared-ui/lodging-property-offers';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

interface SharedUiPropertyStickyPriceHeaderProps extends SharedUiWrapperProps {
  currentHotel?: CurrentHotelStore;
  hideCtaButton?: boolean;
  hidePrice?: boolean;
  wrapPriceSummary?: boolean;
}

export const StickyPriceHeaderWrapper: React.FC<SharedUiPropertyStickyPriceHeaderProps> = inject('currentHotel')(
  observer(({ inputs, hidePrice, hideCtaButton, wrapPriceSummary }) => (
    // Moved gating for this component to the consumer layer to prevent over-bucketing.
    // Consider moving any hard restrictions back into this layer for launch. e.g. no H+H or PKG paths.

    <PropertyStickyPriceHeader
      inputs={inputs}
      focusTargetRef="Offers"
      skipSsr={true}
      hidePrice={hidePrice}
      hideCtaButton={hideCtaButton}
      wrapPriceSummary={wrapPriceSummary}
    />
  ))
);

StickyPriceHeaderWrapper.displayName = 'StickyPriceHeaderWrapper';

export const SharedUiStickyPriceHeaderWrapper = withSharedUiPropertyOffers(StickyPriceHeaderWrapper);
